import { Plus, Trash2 } from "lucide-react";

const inputCls = "w-20 rounded-md border border-white/10 bg-[#0A0A0A] px-3 py-2 text-sm outline-none focus:ring-2 focus:ring-[#FF5A00]";

export const DurationDiscountsCard = ({ tiers, onChange }) => {
  const setTier = (i, k, v) => onChange(tiers.map((t, j) => (j === i ? { ...t, [k]: v } : t)));
  return (
    <div className="rounded-lg border border-white/10 bg-[#141414] p-5" data-testid="pricing-discounts">
      <h2 className="text-lg font-semibold">Long booking discounts</h2>
      <p className="mt-1 text-sm text-neutral-400">Automatic discount on the base hourly fare for the whole booking. The highest matching tier applies.</p>
      <div className="mt-4 space-y-2">
        {tiers.map((t, i) => (
          <div key={i} className="flex flex-wrap items-center gap-2 text-sm" data-testid={`pricing-discount-${i}`}>
            More than
            <input type="number" min="4" value={t.min_hours} onChange={(e) => setTier(i, "min_hours", e.target.value)} data-testid={`pricing-discount-hours-${i}`} className={inputCls} />
            hrs →
            <input type="number" min="1" max="90" value={t.pct} onChange={(e) => setTier(i, "pct", e.target.value)} data-testid={`pricing-discount-pct-${i}`} className={inputCls} />
            % off
            <button onClick={() => onChange(tiers.filter((_, j) => j !== i))} data-testid={`pricing-discount-remove-${i}`} className="rounded-md p-2 text-rose-400 hover:bg-white/10" aria-label="Remove tier"><Trash2 className="h-4 w-4" /></button>
          </div>
        ))}
        {tiers.length === 0 && <p className="text-sm text-neutral-500">No discounts — every booking pays the full hourly fare.</p>}
        <button onClick={() => onChange([...tiers, { min_hours: 96, pct: 35 }])} data-testid="pricing-discount-add" className="flex items-center gap-1 text-sm text-[#FF5A00]"><Plus className="h-4 w-4" />Add tier</button>
      </div>
    </div>
  );
};

export const cleanTiers = (tiers) => {
  const out = tiers.map((t) => ({ min_hours: Number(t.min_hours), pct: Number(t.pct) }));
  const bad = out.find((t) => !Number.isInteger(t.min_hours) || t.min_hours < 4 || !Number.isInteger(t.pct) || t.pct < 1 || t.pct > 90);
  if (bad) return { error: "Each discount tier needs whole hours (4 or more) and a discount of 1–90%" };
  if (new Set(out.map((t) => t.min_hours)).size !== out.length) return { error: "Each discount tier needs a different number of hours" };
  return { tiers: out };
};
